var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1408 6.99398L16.297 13.744C16.2376 14.2201 16.0063 14.6582 15.6466 14.9758C15.2869 15.2934 14.8236 15.4687 14.3438 15.4688H2.25C1.87704 15.4688 1.51935 15.3206 1.25563 15.0569C0.991908 14.7931 0.84375 14.4355 0.84375 14.0625V7.875C0.84375 7.69033 0.880124 7.50747 0.950794 7.33685C1.02147 7.16624 1.12505 7.01121 1.25563 6.88063C1.38621 6.75005 1.54124 6.64647 1.71185 6.5758C1.88247 6.50512 2.06533 6.46875 2.25 6.46875H5.10328L7.68305 1.30992C7.75314 1.16985 7.86084 1.05205 7.99409 0.969718C8.12733 0.887385 8.28087 0.843768 8.4375 0.84375C9.25773 0.844681 10.0441 1.17093 10.6241 1.75092C11.2041 2.3309 11.5303 3.11727 11.5312 3.9375V4.78125H15.1875C15.4666 4.78129 15.7425 4.84068 15.9969 4.95548C16.2514 5.07028 16.4785 5.23786 16.6632 5.44711C16.8479 5.65635 16.986 5.90249 17.0683 6.16918C17.1507 6.43587 17.1754 6.71702 17.1408 6.99398Z",
    fill: "#053F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpFilled);
export default __webpack_public_path__ + "static/media/ThumbsUpFilled.a513fc3cd2d802644493103326cd0b4f.svg";
export { ForwardRef as ReactComponent };